export const LIGHT_THEME_BACKGROUND = '#f0eaf0'
export const PRIMARY_PURPLE = '#7f358c'

export const DEFAULT_DARK_BACKGROUND_COLOR = '#17051b'
export const DEFAULT_LIGHT_BACKGROUND_COLOR = '#f5f0f7'
